import { subjectPhotoGradient } from "Components/WebsiteTheme/subjectPhoto.style";
import styled from "styled-components";
import { C, MQ } from "Components/WebsiteTheme/WebsiteTheme.style";

/* Subjects intro in the Home and About page style: heading left, intro right, logo cards below */
export const SubjectsIntroContainer = styled.section`
	.si_grid {
		display: grid;
		grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.4fr);
		align-items: start;
		gap: 56px;

		${MQ.TABLET} {
			grid-template-columns: 1fr;
			gap: 20px;
		}
	}

	.si_text {
		display: flex;
		flex-direction: column;
		gap: 16px;

		strong {
			color: ${C.navy};
			font-weight: 700;
		}
	}

	.si_logos {
		display: grid;
		grid-template-columns: repeat(7, minmax(0, 1fr));
		gap: 16px;
		margin-top: 48px;

		${MQ.STACK} {
			grid-template-columns: repeat(4, minmax(0, 1fr));
		}

		${MQ.PHONE} {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 12px;
			margin-top: 36px;
		}

		li {
			display: flex;
		}
	}

	.si_logo {
		position: relative;
		display: block;
		width: 100%;
		aspect-ratio: 10 / 11;
		overflow: hidden;
		border: 0;
		border-radius: 12px;
		padding: 0;
		background: ${C.navy};
		box-shadow: 0 10px 24px -16px rgba(20, 42, 110, 0.6);
		font-family: inherit;
		cursor: pointer;
		transition: transform 0.35s ${C.ease}, box-shadow 0.35s ${C.ease};

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: transform 0.6s ${C.ease};
		}

		${subjectPhotoGradient}

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 18px 32px -16px rgba(20, 42, 110, 0.6);

			img {
				transform: scale(1.06);
			}
		}

		&:focus-visible {
			outline: 3px solid ${C.blue};
			outline-offset: 3px;
		}

		${MQ.STACK} {
			aspect-ratio: 4 / 3;
		}

		${MQ.PHONE} {
			aspect-ratio: 1 / 1;
		}
	}

	.si_logo span {
		position: absolute;
		right: 10px;
		bottom: 12px;
		left: 12px;
		z-index: 1;
		color: #fff;
		font-size: 16px;
		font-weight: 700;
		line-height: 1.2;
		text-align: left;

		${MQ.PHONE} {
			font-size: 15px;
		}
	}
`;
